module.exports = __webpack_public_path__ + "static/media/left-arrow.c7121221.svg";